import type { PeriodType } from '@/api/base/enums'
import type { Amount } from '@/types/interfaces'
import type { SearchFieldOption } from '@/types/modules/search'

export interface TeamUserFormOption {
  // 表单绑定的字段名
  value: string
  // 占据的行数
  span: number
  // 是否必填
  required: boolean
  // 表单校验信息
  message?: string
  // 是否隐藏label
  hideLabel?: boolean
  // 是否隐藏
  visible?: boolean
}

export type TeamUserFormOptions = TeamUserFormOption & SearchFieldOption

export interface SetGoalsData {
  // 周期类型
  type: PeriodType
  // 年份
  year: number | string
  // 目标金额
  price: Amount
  // 盈利金额
  profit: Amount
  // 用户ID
  userId?: string
  // 团队ID
  organizationId?: string
  // 用户名称
  userName?: string
}

// 公告阅读记录结构体
export interface NoticeReadOptions {
  // 是否已读
  read: boolean
  // 确认时间
  confirmTime: number
}

// 公告阅读状态开关
export enum NoticeReadStatus {
  // 开启
  OPEN = '1',
  // 关闭
  CLOSE = '2',
}

// 仓库地址类型
export interface WarehouseAddress {
  id: string
  name: string
  nameCn: string
  port: string
  country: string
  countryCn: string
  province: string
  provinceCn: string
  city: string
  cityCn: string
  district: string
  districtCn: string
  exact: string
  addressKey: string
  latitude: number
  longitude: number
  syncLocation: number
  contactName: string
  contactEmail: string
  contactMobile: string
  contactCompanyTel: string
  postalCode: string
  wmWarehouseId: string
  type: number
  code: string
  shipToId: string
}

// 节点类型
export interface ShippingNode {
  vmId: string
  type: number
  status: number
  isShow: number
  completedTime: string
  estimatedTime: string
  outEstimatedTime: string
  contentString: string
  entityId: string
}

// 运单详情类型
export interface ShippingDetail {
  departurePort: string[]
  arrivalPort: string[]
  departurePortNameCns: string[]
  arrivalPortNameCns: string[]
  shippingDocumentId: string
  sssCode: string
  type: number
  status: number
  orderCode: string
  customerName: string
  customerId: string
  deliveryMode: number
  createdAt: string
  tradeTerms: string
  nodes: ShippingNode[]
  orderCodes: string[]
  top: boolean
  pickUpTime: string
  outStockTime: string
  orderTime: string
  orderId: string
  stockAddressId: string
  deliveryAddressId: string
  transloadWarehouse: WarehouseAddress
  terminalWarehouse: WarehouseAddress
  latestDeliveryTime: string
  submitApproveTime: string
  completedTime: string
  verifiedTime: string
  returnApproveTime: string
  modeType: number
  batchNo: string
  batchNos: string[]
  businessLineTypes: number[]
}
